import { render, staticRenderFns } from "./IconQuiz.vue?vue&type=template&id=088a5b10&"
import script from "./IconQuiz.vue?vue&type=script&lang=js&"
export * from "./IconQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports